
        // generated by Jenkins
        const api_config = {
          hostname: "https://api.xapit.com/api/rest",
        };
        export default api_config;
        